var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loaded
        ? _c(
            "b-dropdown",
            {
              staticClass: "apply-inline-button",
              attrs: {
                "toggle-class": _vm.dropdownToggleClass,
                variant: _vm.variant
              }
            },
            [
              _c(
                "template",
                { slot: "button-content" },
                [
                  _vm.noRegisterDefined
                    ? _c("ItpText", {
                        attrs: {
                          text: _vm._f("pgettext")(
                            "No register have been defined yet.",
                            "RegisterSelector"
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.noRegisterDefined && !_vm.selectedRegister
                    ? _c("ItpText", {
                        attrs: {
                          text: _vm._f("pgettext")(
                            "Select register",
                            "RegisterSelector"
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedRegister && _vm.selectedRegister.register
                    ? _c(
                        "DIV",
                        [
                          _c(
                            "ItpText",
                            {
                              attrs: {
                                muted: _vm.selectedRegister.register.inactive,
                                strikethrough:
                                  _vm.selectedRegister.register.inactive
                              }
                            },
                            [
                              _c("span", { staticClass: "pr-1" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.selectedRegister.register.name) +
                                    "\n          "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.registers, function(register) {
                return _c(
                  "b-dropdown-item-button",
                  {
                    key: register.id,
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.evh_5962862420439144_clickPrevent($event, {
                          register: register
                        })
                      }
                    }
                  },
                  [
                    _c(
                      "ItpText",
                      {
                        attrs: {
                          muted: register.inactive,
                          strikethrough: register.inactive
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            "\n          " +
                              _vm._s(register.name) +
                              "\n        "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.noRegisterDefined ? _c("b-dropdown-divider") : _vm._e(),
              _vm._v(" "),
              _c("ItpNavItem", {
                attrs: {
                  href: "#",
                  "dropdown-item": "",
                  icon: "fa-cog",
                  text: _vm._f("pgettext")(
                    "Configure registers...",
                    "RegisterSelector"
                  )
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.evh_1048678296148443_clickPrevent($event, {})
                  }
                }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded &&
      !_vm.noRegisterDefined &&
      _vm.selectedRegister &&
      _vm.selectedRegister.register
        ? _c(
            "b-dropdown",
            {
              staticClass: "apply-inline-button mx-2",
              attrs: {
                "toggle-class": _vm.dropdownToggleClass,
                variant: "light"
              }
            },
            [
              _c(
                "template",
                { slot: "button-content" },
                [
                  _c(
                    "ItpText",
                    {
                      attrs: {
                        muted:
                          _vm.selectedRegister.version &&
                          _vm.selectedRegister.version.inactive,
                        strikethrough:
                          _vm.selectedRegister.version &&
                          _vm.selectedRegister.version.inactive
                      }
                    },
                    [
                      _c("span", { staticClass: "pr-1" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.selectedRegister.version &&
                                _vm.selectedRegister.version.name
                            ) +
                            "\n        "
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.selectedRegister.register.versions.data, function(
                version
              ) {
                return _c(
                  "b-dropdown-item-button",
                  {
                    key: version.id,
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.evh_5974459770896956_clickPrevent($event, {
                          version: version
                        })
                      }
                    }
                  },
                  [
                    _c(
                      "ItpText",
                      {
                        attrs: {
                          muted: version.inactive,
                          strikethrough: version.inactive
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            "\n          " + _vm._s(version.name) + "\n        "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }